import type { ConversionTracked } from "@/hooks/eventing/types/core.conversions.ConversionTracked.v2";
import { TagularAction, TagularCategory } from "@/types/Tagular";
import type { CartItem } from "@/utils/cartUtils";
import {
  TagularVariant,
  translateVariant,
} from "@/utils/tagular/dataTranslationMatrices";

const getVariant = (productType?: string) =>
  productType
    ? (translateVariant(productType) ?? TagularVariant.Courses)
    : TagularVariant.Courses;

export const createBannerElementViewEventData = (
  location: string,
  productName: string,
  correlationId?: string,
) => ({
  webElement: {
    elementType: "banner",
    htmlId: "banner",
    location,
    name: "abandoned-cart-banner",
    text: `Still interested in ${productName}?`,
  },
  correlationId,
});

export const createBannerCheckoutClickEventData = (
  location: string,
  productName: string,
  correlationId?: string,
) => ({
  webElement: {
    elementType: "button",
    htmlId: "banner",
    location,
    name: "abandoned-cart-banner",
    text: `Still interested in ${productName}?`,
  },
  correlationId,
});

export const createBannerProductViewEventData = (
  item: CartItem,
  index: number,
  location?: string,
  cartBrand?: string | null,
  correlationId?: string,
) => ({
  product: {
    brand: cartBrand ?? item.brand ?? "edX",
    category: item.type ?? "course",
    formatSubtype: "banner",
    formatType: "cart-intent-match",
    location,
    name: item.courseName,
    position: index + 1,
    productId: item.id,
    variant: getVariant(item.type),
  },
  viewCorrelationId: correlationId || "abandoned-cart-banner",
});

export const createBannerConversionEventData = (
  items: CartItem[],
  cartBrand?: string | null,
  correlationId?: string,
): ConversionTracked => ({
  correlation: {
    id: correlationId || "",
  },
  metadata: {
    action: TagularAction.STARTED,
    category: TagularCategory.ENROLLMENT,
    timestamp: new Date().toISOString(),
    productList: items.map((item) => ({
      brand: cartBrand ?? item.brand ?? "edX",
      category: item.type ?? "course",
      variant: getVariant(item.type),
      name: item.courseName,
      id: item.courseKey,
      externalId: item.courseRunKey,
    })),
  },
});
